// Lib
import React from 'react';
import PropTypes from 'prop-types';

// Utils
import { isIpad } from '../../utils/services/browser';
import { focusFakeInputFromMouseEvent } from '../../utils/ipad/ipadUtils';

export default (DecoratedComponent) => {
    class doubleClickWithoutDragDecorator extends React.Component {
        constructor(props) {
            super(props);

            this.allowDoubleClickCreate = true;
            this.mouseDownTimestamp = null;
            this.mouseDownPos = null;

            this.mouseUpTimestamp = 0;
        }

        onMouseDown = (event) => {
            this.mouseDownTimestamp = Date.now();
            this.mouseDownPos = {
                x: event.pageX,
                y: event.pageY,
            };
        };

        // NOTE: While the double tap code is specifically used for iPads, strangely using pointer
        //  events here doesn't correctly set the focus for virtual keyboard either, so we need to
        //  use mouse events.
        onMouseUp = (event) => {
            // If we don't have a mouse down, for whatever reason, don't check if it was a drag
            if (!this.mouseDownTimestamp || !this.mouseDownPos) return;

            const currentTimestamp = Date.now();
            const pressTime = currentTimestamp - this.mouseDownTimestamp;

            this.allowDoubleClickCreate =
                pressTime < 120 || (this.mouseDownPos.x === event.pageX && this.mouseDownPos.y === event.pageY);

            // HACK - Similar to in the DraggableElementCreationTool, we need to focus a fake input field
            //  synchronously to the *mouse* event in order to then asynchronously transfer focus over to the
            //  new element on double click creation.
            //  Strangely, however, we need to focus the first mouseup in the double click in order to get
            //  the focus and virtual keyboard to show on the second.
            const isDoubleTap = !!this.mouseUpTimestamp && currentTimestamp - this.mouseUpTimestamp < 300;

            if (isIpad() && this.allowDoubleClickCreate) {
                focusFakeInputFromMouseEvent(event, !isDoubleTap);
            }

            this.mouseUpTimestamp = currentTimestamp;
            this.mouseDownTimestamp = null;
            this.mouseDownPos = null;
        };

        onDoubleClick = (event) => {
            if (!this.allowDoubleClickCreate) {
                this.allowDoubleClickCreate = true;
                return;
            }

            this.allowDoubleClickCreate = true;

            const { onDoubleClick } = this.props;
            onDoubleClick && onDoubleClick(event);
        };

        render() {
            return (
                <DecoratedComponent
                    {...this.props}
                    onMouseDown={this.onMouseDown}
                    onMouseUp={this.onMouseUp}
                    onDoubleClick={this.onDoubleClick}
                />
            );
        }
    }

    doubleClickWithoutDragDecorator.propTypes = {
        onDoubleClick: PropTypes.func,
    };

    return doubleClickWithoutDragDecorator;
};
